import { api } from "@data-phone/react-resource-server-auth";
import qs from "qs";
import { useQuery } from "react-query";
import { BaseMessage } from "../../interfaces/messages.type";
import { castArray } from "../../utils/helpers";

export interface SmsStatistics {
    total: number;
    failed: number;
    pending: number;
    unread: number;
    read: number;
    delivered: number;
    received: number;
    scheduled: number;
    bulk_messages: number;
    resolved: number;
    unresolved: number;
    assigned: number;
    unassigned: number
}

type ReportStatus = 'sent' | 'delivered' | 'failed' | 'received';

export interface SmsReportQuery {
    offset: number;
    limit: number;
    start_date: Date;
    end_date: Date;
    start_time: Date | null;
    end_time: Date | null;
    direction: string | null;
    user: string | null;
    account_id?: string;
    dids: string[] | null;
    status: ReportStatus | ReportStatus[] | null;
    searchInput: string | null;
}

/**
 * Handles adding "delivered" status when "sent" status is present.
 */
function handleDelivered(query: SmsReportQuery): SmsReportQuery {
    let status = query.status;
   if (status && castArray(status).includes("sent")) {
        status = [...castArray(status), "delivered"];
   }

   return { ...query, status };
}

const getSmsReportApi = async (query: SmsReportQuery) => {
    const response = await api.get(`${process.env.REACT_APP_SMS_API_URL}/sms/reports?${qs.stringify(handleDelivered(query))}`);
    return response.data;
};

export const useGetSmsReport = (query?: SmsReportQuery | null) => {
    return useQuery<{ messages: BaseMessage[]; statistics: SmsStatistics }, Error>({
        queryKey: ["smsReport", query],
        queryFn: () => {
            if (!query) {
                return Promise.resolve({ messages: [], statistics: {} as any });
            }
            return getSmsReportApi(query as any);
        },
        enabled: false
    });
};
